import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { ListSelectable } from "src/model/class/general classes/list-selectable";
import { Notific } from "src/model/class/general classes/notific";
import { InnerComponentDataError } from "src/model/enum/enumInnerComponentDataError";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { LoggerService } from "src/service/logger.service";

@Component({
    selector: "app-popup-content-list-notification",
    templateUrl: "./popup-content-list-notification.component.html",
    styleUrls: ["./popup-content-list-notification.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupContentListNotificationComponent implements OnInit, OnDestroy, iEvent {
  private _logContext: string = "Popup-content-list-notification.component";
  private listNotificationSelected: Array<Notific> = new Array<Notific>();
  public _eventSubscriptions: Array<Subscription> = null;

  //#region Error-component display flags 

  //LIST-NOTIFICATIONS
  public showErrorContentNotificationListSection: boolean = false;
  public forceReloadNotificationListSection: boolean = false;

  public InnerComponentDataError = InnerComponentDataError;

  //#endregion

  @Input() title: string;
  @Input() subTitle: string;
  @Input() showWithAudio: boolean;
  @Input() showWithBalloon: boolean;
  @Input() showWithMail: boolean;
  @Input() showWithPageJump: boolean;
  @Input() showWithPopup: boolean;
  @Input() showWithSMS: boolean;

  constructor(
    private _modalController: ModalController,
    private _eventService: EventService,
    private _loggerService: LoggerService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Handle callback event from inner notification input
   *
   * @param listNotification New list notification updated
   */
  public onListNotificationSelectUpdated(listNotification: any): void {
    this.listNotificationSelected = listNotification;
  }

  /**
   * Close button: dismisses without data, the same result as a tap on the backdrop
   */
  public onClickClose(): void {
    this._modalController.dismiss();
  }

  /**
   * handle callback event button save
   */
  public onClickSave(): void {
    this._modalController.dismiss(this.listNotificationSelected);
  }


  /**
 * Handle error occurrence inside one of the inner components, if these ones can NOT handle it by themselves.
 * It does so "switching out" the problematic inner component with the "app-error-content.component"
 * @param componentWithError Enum value, it signal the type of inner component where the error has occurred
 */
  public handleInnerComponentError(componentWithError: InnerComponentDataError): void {
    switch (componentWithError) {
      case InnerComponentDataError.LIST_NOTIFICATIONS:

        this.showErrorContentNotificationListSection = true;
        break;

      default:
        this._loggerService.log(
          LogLevel.LOG_ERROR,
          this._logContext,
          this._logContext,
          "handleInnerComponentError()",
          "Unspecified inner component"
        );
        break;
    }
  }


  /**
* Handle the reaction to a error which can possibly occur inside one of the inner components.
* It does so "switching in" a new instance of the inner component instead of the "app-error-content.component" inserted when
* the error was first signaled, also passing the new instance an input property directing it to exceute all its peculiar actions
* needed to overcome the error.
* @param componentToBeReloaded Enum value, it signal the type of inner component where the error to be handled has occurred
*/
  public forceInnerComponentReload(componentToBeReloaded: InnerComponentDataError): void {
    switch (componentToBeReloaded) {
      case InnerComponentDataError.LIST_NOTIFICATIONS:

        this.forceReloadNotificationListSection = true;
        this.showErrorContentNotificationListSection = false;
        break;

      default:
        this._loggerService.log(
          LogLevel.LOG_ERROR,
          this._logContext,
          this._logContext,
          "forceInnerComponentReload()",
          "Unspecified inner component"
        );
    }
  }

}
